import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectAnalyticsOfferStatus } from '../../../selectors/analytics';
import { IAdaptiveSettings } from '../../../types/adaptiveSettings';
import { TAnalyticsOfferStatus, TAnalyticsSiteType } from '../../../types/analytics';
import { getAnalyticsSiteType } from '../../../utils';
import { useApplicationContext } from '../../ApplicationContext';

export type TE2eLabelTrackingFunction<T = Record<string, unknown>> = (
  args: { siteType: TAnalyticsSiteType; offerStatus: TAnalyticsOfferStatus } & T,
) => void;

// Добавляет тип девайса и статус сделки ('New_ad' <-> 'Edit_ad') в событие аналитики
export function useE2eLabelTracking<T extends TE2eLabelTrackingFunction>(trackingFunction: T) {
  const offerStatus = useSelector(selectAnalyticsOfferStatus);
  const { config } = useApplicationContext();

  const siteType = React.useMemo(
    () => getAnalyticsSiteType(config.get<IAdaptiveSettings>('adaptiveSettings')?.deviceType),
    [config],
  );

  return (extraParams: Omit<Parameters<T>[0], 'siteType' | 'offerStatus'>) =>
    trackingFunction({ siteType, offerStatus, ...extraParams });
}
